import { useTheme } from '../context/ThemeContext'

const ThemeSwitcher = () => {
	const { theme, toggleTheme } = useTheme()
	const isDark = theme === 'dark'

	return (
		<button
			onClick={toggleTheme}
			className={`flex items-center justify-center w-9 h-9 rounded-lg transition-all duration-300 cursor-pointer ${
				isDark
					? 'text-white/70 hover:text-white hover:bg-white/10'
					: 'text-slate-900/70 hover:text-slate-900 hover:bg-black/5'
			}`}
			aria-label={isDark ? 'Switch to light mode' : 'Cambiar a modo oscuro'}
		>
			{theme === 'dark' ? (
				<svg
					className='w-[18px] h-[18px]'
					fill='none'
					stroke='currentColor'
					viewBox='0 0 24 24'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth={2}
						d='M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z'
					/>
				</svg>
			) : (
				<svg
					className='w-[18px] h-[18px]'
					fill='none'
					stroke='currentColor'
					viewBox='0 0 24 24'
				>
					<path
						strokeLinecap='round'
						strokeLinejoin='round'
						strokeWidth={2}
						d='M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z'
					/>
				</svg>
			)}
		</button>
	)
}

export default ThemeSwitcher
